import * as React from 'react';
import { fileApi } from "../../services/file.service";

export interface IUploadTemporaryFileProps {
    onUpdated: Function;
    allowedFileTypes?: string[];
    isImage?: boolean;
    text? : string;
}

interface IUploadTemporaryFileState {
    fileName: string;
    allowedFileTypes: string[];
    isImage: boolean;
}

export default class UploadTemporaryFile extends React.Component<IUploadTemporaryFileProps, IUploadTemporaryFileState> {
    constructor(props: IUploadTemporaryFileProps) {
        super(props);
        this.state = {
            fileName: "",
            isImage: props.isImage !== undefined ? props.isImage : false,
            allowedFileTypes: props.allowedFileTypes || []
        }
        this.onChanged = this.onChanged.bind(this);
        this.triggerInputFile = this.triggerInputFile.bind(this);
    }

    fileInput: any;

    onChanged(e) {
        let self = this;
        const files = Array.from(e.target.files);
        fileApi.upload(files, this.props.isImage !== undefined ? this.props.isImage : false)
            .then(response => {
                self.props.onUpdated(response.imgPath);
            })
            .catch(e => {
                console.error(e);
            });
        e.target.value = '';
    }

    triggerInputFile = () => this.fileInput.click();


    render() {
        return (
        <div>
            <input
                ref={fileInput => (this.fileInput = fileInput)}
                type="file"
                style={{ display: "none" }}
                onChange={this.onChanged}
                accept={this.state.allowedFileTypes.join(",")}
            />
            <button type="button" onClick={this.triggerInputFile} className="btn btn-default">
                {this.props.text || "Choose file"}
            </button>
        </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/controls/UploadTemporaryFile.tsx